// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__YE0-7","modal":"styles_modal__5D1PS","closeButton":"styles_closeButton__mrn83","modalContent":"styles_modalContent__PQGR8"};